import { Flame } from '@sorare/core/src/atoms/icons/Flame';
import { BrandS, BrandXXS } from '@sorare/core/src/atoms/typography';
import { css } from '@sorare/css';

import squadImg from '#src/assets/squad.webp';

const levelBadge = css`
  position: absolute;
  top: calc(-1 * var(--half-unit));
  right: calc(-1 * var(--half-unit));
  display: grid;
  place-items: center;
  > * {
    grid-area: 1 / 1;
  }
`;

const levelNumber = css`
  text-shadow:
    0 0 4px var(--c-rare),
    0 -3px 4px var(--c-black);
`;

type Props = {
  level?: number | null;
  large?: boolean;
};

export const SquadEmblem = ({ level, large }: Props) => {
  const imgSize = large ? 80 : 48;
  const LevelTypography = large ? BrandS : BrandXXS;

  return (
    <div className="relative">
      <img
        src={squadImg}
        alt=""
        width={imgSize}
        height={imgSize}
        className="object-contain"
      />
      {!!level && (
        <div className={levelBadge}>
          <Flame size={large ? 4 : 2.5} />
          <LevelTypography color="var(--c-white)" className={levelNumber}>
            {level}
          </LevelTypography>
        </div>
      )}
    </div>
  );
};
